import { ShareStoryMeta, ShareStoryPayload } from 'types/store/ShareStory';
import { createAsyncAction } from 'utils/Redux';

const ns = 'SHARE_STORY_NS';

const asyncAction = createAsyncAction<ShareStoryMeta, ShareStoryPayload>(ns);

const shareStoryActions = { ...asyncAction };

export default shareStoryActions;
